export function parseRequiredHashtags(
  text: string | null | undefined,
  includeFacebook = false,
): { tiktok: string; instagram: string; youtube: string; facebook?: string } {
  if (!text) return { tiktok: '', instagram: '', youtube: '', ...(includeFacebook ? { facebook: '' } : {}) };
  const lines = text.split(/\r?\n/);
  const result: Record<string, string[]> = {};
  let currentPlatform: string | null = null;
  let hasPlatformHeaders = false;
  for (const rawLine of lines) {
    const line = rawLine.trim();
    if (!line) continue;
    const match = line.match(/^([A-Za-z][A-Za-z\s]{0,20})\s*[:\-—–]\s*(.*)$/);
    if (match) {
      hasPlatformHeaders = true;
      currentPlatform = match[1].trim().toUpperCase();
      result[currentPlatform] = [];
      if (match[2].trim()) result[currentPlatform].push(match[2].trim());
    } else if (currentPlatform) {
      result[currentPlatform].push(line);
    }
  }
  if (!hasPlatformHeaders) {
    const flat = text.trim();
    return { tiktok: flat, instagram: flat, youtube: flat, ...(includeFacebook ? { facebook: flat } : {}) };
  }
  const get = (...keys: string[]) => {
    const key = Object.keys(result).find((k) => keys.some((p) => k.includes(p)));
    return key ? result[key].join(' ').trim() : '';
  };
  return {
    tiktok: get('TIKTOK'),
    instagram: get('INSTAGRAM', 'REELS'),
    youtube: get('YOUTUBE', 'SHORTS'),
    ...(includeFacebook ? { facebook: get('FACEBOOK') } : {}),
  };
}
